import React from 'react';
import { Link } from "react-router-dom";
import { Layout, Menu, Icon, Card, Row, Col, Slider, Divider, Progress } from 'antd';
import '../../assets/css/App.css';
import Header1 from '../public';
import BicombImg from "../../assets/images/irAEs.jpg";

const { Content, Sider } = Layout;
const SubMenu = Menu.SubMenu;

class irAEsModel extends React.Component {
  constructor(props) {
    super(props);

    this.nomogramConfig = {
      age: {
        label: "Age",
        options: [
          { label: "<65y", value: "<65y", points: 0 },
          { label: "≥65y", value: "≥65y", points: 12 },
        ],
      },
      sex: {
        label: "Sex",
        options: [
          { label: "Female", value: "Female", points: 0 },
          { label: "Male", value: "Male", points: 8 },
        ],
      },
      smoking: {
        label: "Smoking",
        options: [
          { label: "Yes", value: "Yes", points: 0 },
          { label: "No", value: "No", points: 5 },
        ],
      },
      histology: {
        label: "Histology",
        options: [
          { label: "LUAD", value: "LUAD", points: 0 },
          { label: "LUSC", value: "LUSC", points: 9 },
          { label: "Other", value: "Other", points: 92 },
        ],
      },
      stage: {
        label: "Stage",
        options: [
          { label: "IV", value: "IV", points: 0 },
          { label: "I~III", value: "I~III", points: 92 },
        ],
      },
      line: {
        label: "Line",
        options: [
          { label: "≥2L", value: "≥2L", points: 0 },
          { label: "1L", value: "1L", points: 97 },
        ],
      },
      regimen: {
        label: "Regimen",
        options: [
          { label: "Chemo", value: "Chemo", points: 0 },
          { label: "Mono", value: "Mono", points: 51 },
          { label: "Other", value: "Other", points: 100 },
        ],
      },
    };

    this.state = {
      selections: {
        age: 0,
        sex: 0,
        smoking: 0,
        histology: 0,
        stage: 0,
        line: 0,
        regimen: 0,
      },
    };
  }

  handleSliderChange = (key, value) => {
    this.setState((prevState) => ({
      selections: {
        ...prevState.selections,
        [key]: value,
      },
    }));
  };

  getSelectedOption = (key) => {
    const idx = this.state.selections[key];
    return this.nomogramConfig[key].options[idx];
  };

  getVariablePoints = (key) => {
    return this.getSelectedOption(key).points;
  };

  getTotalPoints = () => {
    const keys = Object.keys(this.nomogramConfig);
    return keys.reduce((sum, key) => sum + this.getVariablePoints(key), 0);
  };

  // 基于图中 Total Points -> Risk 刻度做近似插值
  // 你后续如果有精确模型系数，可替换为真实 logistic 计算
  pointsToRisk = (points) => {
    const anchors = [
      { points: 0, risk: 0.0 },
      { points: 28, risk: 0.30 },
      { points: 100, risk: 0.50 },
      { points: 170, risk: 0.70 },
      { points: 270, risk: 0.90 },
    ];

    if (points <= anchors[0].points) return anchors[0].risk;
    if (points >= anchors[anchors.length - 1].points) return anchors[anchors.length - 1].risk;

    for (let i = 0; i < anchors.length - 1; i++) {
      const a = anchors[i];
      const b = anchors[i + 1];
      if (points >= a.points && points <= b.points) {
        const t = (points - a.points) / (b.points - a.points);
        return a.risk + t * (b.risk - a.risk);
      }
    }
    return 0.50;
  };

  renderMarks = (options) => {
    const marks = {};
    options.forEach((opt, idx) => {
      marks[idx] = {
        style: {
          fontSize: 13,
          whiteSpace: 'nowrap',
        },
        label: opt.label,
      };
    });
    return marks;
  };

  renderSliderRow = (key) => {
    const config = this.nomogramConfig[key];
    const selected = this.getSelectedOption(key);

    return (
      <Card
        key={key}
        bordered={false}
        style={{
          marginBottom: 18,
          borderRadius: 12,
          boxShadow: '0 2px 10px rgba(0,0,0,0.06)',
        }}
        bodyStyle={{ padding: '8px 12px 6px 12px' }}
      >
        <Row gutter={16} type="flex" align="middle">
          <Col xs={24} md={5}>
            <div style={{ fontSize: 18, fontWeight: 600, color: '#1f1f1f' }}>
              {config.label}
            </div>
            <div style={{ marginTop: 8, fontSize: 14, color: '#666' }}>
              Selected: <span style={{ fontWeight: 600, color: '#0050b3' }}>{selected.label}</span>
            </div>
          </Col>

          <Col xs={24} md={13} style={{ paddingTop: 10 }}>
            <Slider
              min={0}
              max={config.options.length - 1}
              step={1}
              marks={this.renderMarks(config.options)}
              value={this.state.selections[key]}
              onChange={(value) => this.handleSliderChange(key, value)}
              tooltipVisible={false}
            />
          </Col>

          <Col xs={24} md={6}>
            <div
              style={{
                background: '#f5faff',
                border: '1px solid #d6e4ff',
                borderRadius: 10,
                padding: '14px 16px',
                textAlign: 'center',
              }}
            >
              <div style={{ fontSize: 13, color: '#666' }}>Points</div>
              <div style={{ fontSize: 28, fontWeight: 700, color: '#0050b3', lineHeight: 1.2 }}>
                {selected.points}
              </div>
            </div>
          </Col>
        </Row>
      </Card>
    );
  };

  render() {
    const totalPoints = this.getTotalPoints();
    const risk = this.pointsToRisk(totalPoints);
    const riskPercent = (risk * 100).toFixed(1);

    return (
      <div>
        <Header1 />
        <Content style={{ padding: '0 50px' }}>
          <Layout style={{ background: '#fff' }}>
            <Sider width={200} style={{ background: '#fff' }}>
              <Menu
                mode="inline"
                selectedKeys={[this.props.location.pathname]}   // ✅ 关键
                defaultOpenKeys={['sub1']}
                style={{
                  height: '100%',
                  borderRight: 0,
                  background: '#fafbfc'
                }}
              >
                <SubMenu
                  key="sub1"
                  title={
                    <span style={{ fontWeight: 600, fontSize: 16 }}>
                      <Icon type="medicine-box" style={{ marginRight: 8 }} />
                      irAEs Module
                    </span>
                  }
                >
                  <Menu.Item key="/irAEs" style={{ paddingLeft: 32 }}>
                    <Link to="/irAEs">
                      <span style={{ fontSize: 15 }}>Introduction</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item key="/irAEsModel" style={{ paddingLeft: 32 }}>
                    <Link to="/irAEsModel">
                      <span style={{ fontSize: 15 }}>irAE Prediction Model</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item key="/severeModel" style={{ paddingLeft: 32 }}>
                                      <Link to="/severeModel">
                                        <span style={{ fontSize: 15 }}>severe irAE Prediction Model</span>
                                      </Link>
                                    </Menu.Item>

                  <Menu.Item key="/PneumonitisModel" style={{ paddingLeft: 32 }}>
                    <Link to="/PneumonitisModel">
                      <span style={{ fontSize: 15 }}>Pneumonitis Model</span>
                    </Link>
                  </Menu.Item>
                </SubMenu>
              </Menu>
            </Sider>

            <Content style={{ padding: '0 50px' }}>
              <div
                style={{
                  background: `url(${BicombImg}) no-repeat center center`,
                  height: 300,
                  width: "100%",
                  backgroundSize: "cover",
                }}
              >
                <div style={{ textAlign: "center", color: "#fff" }}>
                  <br /><br /><br />
                  <span style={{ fontSize: 45, fontWeight: 'bold', color: 'rgb(0, 112, 192)' }}>
                    Immune-related adverse events prediction for
                  </span><br />
                  <span style={{ fontSize: 45, fontWeight: 'bold', color: 'rgb(0, 112, 192)' }}>
                    non-small cell lung cancer
                  </span>
                  <br />
                </div>
              </div>

              <div>
                <br />
                <br />
                <div style={{ fontSize: 23, fontWeight: 'bold', paddingRight: 100 }}>
                  Baseline model for immune-related adverse events (irAEs) risk prediction
                </div>

                <br />

                {/* ===== Interactive Nomogram ===== */}
                <Card
                  bordered={false}
                  style={{
                    marginTop: 20,
                    borderRadius: 16,
                    background: 'linear-gradient(180deg, #fafcff 0%, #ffffff 100%)',
                    boxShadow: '0 4px 18px rgba(0,0,0,0.08)',
                  }}
                  bodyStyle={{ padding: '28px' }}
                >

                  <div style={{ fontSize: 18, color: '#666', lineHeight: 1.8, marginBottom: 24 }}>
                    Drag each variable to the appropriate category. The nomogram will automatically calculate
                    the corresponding points and the predicted risk of irAEs.
                  </div>

                  <Row gutter={24}>
                    <Col xs={24} lg={16}>
                      {Object.keys(this.nomogramConfig).map((key) => this.renderSliderRow(key))}
                    </Col>

                    <Col xs={24} lg={8}>
                      <Card
                        bordered={false}
                        style={{
                          borderRadius: 14,
                          background: '#fbfbfb',
                          boxShadow: '0 2px 12px rgba(0,0,0,0.05)',
                          marginBottom: 18,
                        }}
                        bodyStyle={{ padding: '22px' }}
                      >
                        <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 16 }}>
                          Summary
                        </div>

                        <div
                          style={{
                            border: '1px solid #e6f7ff',
                            background: '#f0f9ff',
                            borderRadius: 12,
                            padding: 18,
                            marginBottom: 18,
                          }}
                        >
                          <div style={{ fontSize: 14, color: '#666' }}>Total Points</div>
                          <div style={{ fontSize: 34, fontWeight: 800, color: '#0050b3', lineHeight: 1.2 }}>
                            {totalPoints}
                          </div>
                          <div style={{ fontSize: 13, color: '#888', marginTop: 6 }}>
                            Nomogram range: 0–350
                          </div>
                        </div>

                        <div
                          style={{
                            border: '1px solid #fff1b8',
                            background: '#fffbe6',
                            borderRadius: 12,
                            padding: 18,
                            marginBottom: 18,
                          }}
                        >
                          <div style={{ fontSize: 14, color: '#666' }}>Predicted Risk of irAE</div>
                          <div style={{ fontSize: 34, fontWeight: 800, color: '#ad6800', lineHeight: 1.2 }}>
                            {riskPercent}%
                          </div>
                          <div style={{ marginTop: 12 }}>
                            <Progress
                              percent={Number(riskPercent)}
                              showInfo={false}
                              strokeWidth={10}
                              status="active"
                            />
                          </div>
                        </div>

                        <Divider style={{ margin: '18px 0' }} />

                        <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 12 }}>
                          Selected profile
                        </div>

                        {Object.keys(this.nomogramConfig).map((key) => {
                          const selected = this.getSelectedOption(key);
                          return (
                            <Row key={key} style={{ marginBottom: 10 }}>
                              <Col span={12}>
                                <span style={{ color: '#555' }}>{this.nomogramConfig[key].label}</span>
                              </Col>
                              <Col span={7}>
                                <span style={{ fontWeight: 600 }}>{selected.label}</span>
                              </Col>
                              <Col span={5} style={{ textAlign: 'right', color: '#0050b3', fontWeight: 700 }}>
                                {selected.points}
                              </Col>
                            </Row>
                          );
                        })}
                      </Card>
                    </Col>
                  </Row>
                </Card>

                <div style={{ fontSize: 20, paddingRight: 200, marginTop: 30 }}>
                  <div>
                    <br /><br />
                    Please cite the following study if use the information in this website:
                    <br /><br />
                    <div style={{ fontStyle: 'italic' }}>
                      Clinical architecture and risk prediction of immune-related toxicity in non-small cell lung cancer treated with immune checkpoint inhibitors: evidence from real-world data.
                    </div>
                    <br /><br />
                  </div>
                </div>
              </div>
            </Content>
          </Layout>
        </Content>
      </div>
    );
  }
}

export default irAEsModel;